import { render } from "./Gradient.vue?vue&type=template&id=726c708a&scoped=true&ts=true"
import script from "./Gradient.vue?vue&type=script&lang=ts"
export * from "./Gradient.vue?vue&type=script&lang=ts"

import "./Gradient.vue?vue&type=style&index=0&id=726c708a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726c708a"]])

export default __exports__